<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.page_heading" [ttModel]="edit.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="edit.prod_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity" [(ttModel)]="edit.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-textarea ttLabel="note" [(ttModel)]="edit.note"></tt-textarea>
        <tt-input ttLabel="reg_by_info" [ttModel]="edit.reg_by_info" ttReadonly></tt-input>
        <tt-input *ngIf="edit.mod_by_info !== ''" ttLabel="mod_by_info" [ttModel]="edit.mod_by_info" ttReadonly></tt-input>
        <tt-button-save ttText="productlink_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
